import { fetchCurrentUser } from '../../ducks/user.duck';
import { setInitialValues as setInitialValuesForPaymentMethods } from '../../ducks/paymentMethods.duck';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { allListSubscription, createSubscription } from '../../util/api';

// ================ Action types ================ //

export const SETUP_INTENT_REQUEST = 'app/SubscriptionPage/SETUP_INTENT_REQUEST';
export const SETUP_INTENT_SUCCESS = 'app/SubscriptionPage/SETUP_INTENT_SUCCESS';
export const SETUP_INTENT_ERROR = 'app/SubscriptionPage/SETUP_INTENT_ERROR';

export const STRIPE_CUSTOMER_REQUEST = 'app/SubscriptionPage/STRIPE_CUSTOMER_REQUEST';
export const STRIPE_CUSTOMER_SUCCESS = 'app/SubscriptionPage/STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'app/SubscriptionPage/STRIPE_CUSTOMER_ERROR';

export const GET_ALL_SUBSCRIPTION = 'app/SubscriptionPage/GET_ALL_SUBSCRIPTION';

// ================ Reducer ================ //

const initialState = {
  setupIntentInProgress: false,
  setupIntentError: null,
  setupIntent: null,
  stripeCustomerFetched: false,
  allsubscription: [],
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SETUP_INTENT_REQUEST:
      return { ...state, setupIntentInProgress: true, setupIntentError: null };
    case SETUP_INTENT_SUCCESS:
      return {
        ...state,
        setupIntentInProgress: false,
        setupIntentError: null,
        setupIntent: payload,
      };
    case SETUP_INTENT_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, setupIntentInProgress: false, setupIntentError: null };
    case STRIPE_CUSTOMER_REQUEST:
      return { ...state, stripeCustomerFetched: false };
    case STRIPE_CUSTOMER_SUCCESS:
      return { ...state, stripeCustomerFetched: true };
    case STRIPE_CUSTOMER_ERROR:
      console.error(payload); // eslint-disable-line no-console
      return { ...state, stripeCustomerFetchError: payload };
    case GET_ALL_SUBSCRIPTION:
      return { ...state, allsubscription: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setupIntentRequest = () => ({ type: SETUP_INTENT_REQUEST });
export const setupIntentSuccess = () => ({ type: SETUP_INTENT_SUCCESS });
export const setupIntentError = e => ({
  type: SETUP_INTENT_ERROR,
  error: true,
  payload: e,
});

export const stripeCustomerRequest = () => ({ type: STRIPE_CUSTOMER_REQUEST });
export const stripeCustomerSuccess = () => ({ type: STRIPE_CUSTOMER_SUCCESS });
export const stripeCustomerError = e => ({
  type: STRIPE_CUSTOMER_ERROR,
  error: true,
  payload: e,
});
export const getAllSubscrptionSuccess = (getSubscription) => ({ type: GET_ALL_SUBSCRIPTION, payload: getSubscription, });
// ================ Thunks ================ //

export const createStripeSetupIntent = () => (dispatch, getState, sdk) => {
  dispatch(setupIntentRequest());
  return sdk.stripeSetupIntents
    .create()
    .then(response => {
      const setupIntent = response.data.data;
      dispatch(setupIntentSuccess(setupIntent));
      return setupIntent;
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'create-setup-intent-failed');
      dispatch(setupIntentError(error));
      return { createStripeSetupIntentSuccess: false };
    });
};

export const stripeCustomer = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerRequest());

  return dispatch(fetchCurrentUser({ include: ['stripeCustomer.defaultPaymentMethod'] }))
    .then(response => {
      dispatch(stripeCustomerSuccess());
    })
    .catch(e => {
      const error = storableError(e);
      log.error(error, 'fetch-stripe-customer-failed');
      dispatch(stripeCustomerError(error));
    });
};

export const handleCreateSubscription = params => async (dispatch, getState, sdk) => {
  try {
    const requestBody = typeof params === 'string' ? { priceId: params } : params;
    const sessionUrl = await createSubscription(requestBody);
    if (sessionUrl) {
      window.location.href = sessionUrl;
    }
  } catch (error) {
    console.error('Error Creating Subsription: ', error)
  }
}
export const getAllSubscription = () => async (dispatch, getState, sdk) => {
  try {
    const getSubscription = await allListSubscription({})
    dispatch(getAllSubscrptionSuccess(getSubscription))
    return getSubscription;
  } catch (error) {
    console.error('Error Creating Subsription: ', error)
  }
}
export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(setInitialValuesForPaymentMethods());
  dispatch(fetchCurrentUser())
  dispatch(getAllSubscription())
  return dispatch(stripeCustomer());
};
